type CheckoutPaymentPayload = {
  value?: number;
  currency?: string;
  product_name?: string;
  tenant_slug?: string;
  payment_method?: string;
};

function getDataLayer() {
  if (typeof window === "undefined") return null;
  return ((window as Window & { dataLayer?: Record<string, unknown>[] }).dataLayer ??= []);
}

/** Dispara tags configuradas no GTM ao exibir a etapa de pagamento do checkout. */
export function pushCheckoutPaymentStep(payload: CheckoutPaymentPayload = {}) {
  const dataLayer = getDataLayer();
  if (!dataLayer) return;

  dataLayer.push({
    event: "checkout_payment",
    page_path: "/checkout/pagamento",
    checkout_step: "payment",
    ...payload
  });
}

type PaymentMethodPayload = CheckoutPaymentPayload & {
  payment_method: string;
};

/** Dispara tags quando o cliente escolhe PIX, cartão etc. (trigger no GTM). */
export function pushCheckoutPaymentMethodSelected(payload: PaymentMethodPayload) {
  const dataLayer = getDataLayer();
  if (!dataLayer) return;

  dataLayer.push({
    event: "select_payment_method",
    page_path: "/checkout/pagamento",
    checkout_step: "payment",
    ...payload
  });
}
